import React, { useState, useEffect, useRef, useContext } from 'react'
import { Row, Col, Container,Form,Button,Table, Modal } from "react-bootstrap";
import { AuthContext } from '../../auth/AuthContext';
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { number_format } from '../../utils/Utils';
import { DatePickerW,DatePickerMonthW } from '../../Components/Components';
import { SwitchComponentProd } from '../../Components/Switch/Switch';

export const TablaOficinas = ({
    state, 
    updateState, 
    loadDataOficinas, 
    setLoadDataOficinas, 
    dataSelect = { 
        opt: "", 
        selectedAgentes: "0", 
        selectedTipos: "0" 
    }
}) => {
    const { usuario } = useContext(AuthContext);
    const { dataOficinas } = state;
    const { info_oficinas = [] } = dataOficinas;
    let history = useHistory();
    const currentYear = new Date().getFullYear();
    const beforeYear = new Date(
        new Date().setFullYear(new Date().getFullYear() - 1)
    ).getFullYear();
    const currentMonth = moment().format("MMMM");

    const [valueSwitch, setValueSwitch] = useState(true);
    const [yearG, setYearG] = useState(currentYear);
    const [search, setSearch] = useState("");
    const [mode, setMode] = useState(false);
    const [month, setMonth] = useState(moment().month(currentMonth).format("M"));
    const [loadDataTable, setLoadDataTable] = useState(false);

    const [selectFilter,setSelectFilter] = useState('0');

    const beforeYearBySelect = new Date(
        new Date().setFullYear(yearG - 1)
    ).getFullYear();
    const before2YearBySelect = new Date(
        new Date().setFullYear(yearG - 2)
    ).getFullYear();

    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (load) {
            setLoadDataTable(true);
            getAvancesAllOficinas();
        } else {
            setLoadDataTable(true);
            getAvancesAllOficinas();
        }
    }, [yearG]);

    useEffect(() => {
        if (loadDataOficinas) {
            setLoadDataTable(true);
            getAvancesAllOficinas();
        }
    }, [dataSelect.selectedAgentes, dataSelect.selectedTipos, loadDataOficinas]);

    if (loadDataTable) {
        return (
            <Col xs={12} md={12} className="mb-3">
                <div
                    className="ws_box"
                    style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
                >
                    <Container fluid>
                        <div className="ws_box_header mb-3">
                            <div className="d-flex justify-content-start align-items-end">
                                <div>
                                    <h2 className="ws_table_agente_title pb-0 mb-2">
                                        Oficinas <span className="ws_table_agente_number">0</span>
                                    </h2>
                                    <Skeleton width="200px" height={20} />
                                </div>
                            </div>
                        </div>
                        <Skeleton width="100%" height={400} />
                    </Container>
                </div>
            </Col>
        );
    }

    if(selectFilter == '0'){
        info_oficinas.sort((a,b)=>{
            return b.nombre_oficina - a.nombre_oficina       
        });
    }

    if(selectFilter == '1'){
        info_oficinas.sort((a,b)=>{
            if (a.cobAcumYearCurrent > b.cobAcumYearCurrent) return -1;
        });
    }

    if(selectFilter == '2'){
        info_oficinas.sort((a,b) => {
            for(let i = 0; i < 12; i++){
                if(a.months_current[i].mes == month){
                    return parseFloat(b.months_current[i].cobranza) - parseFloat(a.months_current[i].cobranza)        
                }
            }
        })
    }

    if(selectFilter == '3'){
        info_oficinas.sort((a,b) => {
            for(let i = 0; i < 12; i++){
                if(a.months_before[i].mes == month){
                    return parseFloat(b.months_before[i].cobranza) - parseFloat(a.months_before[i].cobranza)        
                }
            }
        })
    }

    if(selectFilter == '4'){
        info_oficinas.sort((a,b) => {
            for(let i = 0; i < 12; i++){
                if(a.months_before2[i].mes == month){
                    return parseFloat(b.months_before2[i].cobranza) - parseFloat(a.months_before2[i].cobranza)        
                }
            }
        })
    }

    console.log('info_oficinas2',info_oficinas);

    let filteredData = [];
    if (search == "") {
        filteredData = info_oficinas;
    } else {
        filteredData = info_oficinas.filter((el) => {
            const { clave_oficina, nombre_oficina } = el;
            return (
                clave_oficina.toString().includes(search) ||
                nombre_oficina.toLowerCase().includes(search)   
            );
        });
    }

    // console.log(filteredData);

    return (
        <Col xs={12} md={12} className="mb-3">
            <div
                className="ws_box"
                style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
            >
                <Container fluid>
                    <div className="ws_box_header mb-3">
                        <div className="d-flex justify-content-start align-items-end">
                            <div>
                                <h2 className="ws_table_agente_title pb-0 mb-2">
                                    Oficinas{" "}
                                    <span className="ws_table_agente_number">
                                        {info_oficinas.length}
                                    </span>
                                </h2>
                                <div className="d-flex justify-content-center align-items-center">
                                    <DatePickerW
                                        onChange={(e) => {
                                            setYearG(e.target.value);
                                            setLoad(true);
                                        }}
                                        year={currentYear}
                                        selected={yearG}
                                        label="AÑO"
                                    />
                                    {!mode ? (
                                        <DatePickerMonthW
                                            className="ms-2"
                                            onChange={(e) => {
                                                setMonth(e.target.value);
                                            }}
                                            selected={month}
                                            label="MES"
                                        />
                                    ) : (
                                        ""
                                    )}

                                    {
                                        (!mode) && (
                                            <div className="mb-2">
                                                <Row>
                                                    <Col xs={12}>
                                                        <Form>
                                                            <Form.Label className="ms-2">ORDENAR POR</Form.Label>
                                                            <Form.Select 
                                                            className="w-select-year ms-2"
                                                            onChange={ (e) => setSelectFilter(e.target.value) }
                                                            >
                                                                <option value="0">Elige una opción</option>
                                                                <option value="1">Acum Anual {yearG}</option>
                                                                <option value="2">
                                                                    Prima{" "}
                                                                    {moment()
                                                                        .month(month - 1)
                                                                        .format("MMM")}{" "}
                                                                    {yearG}
                                                                </option>
                                                                <option value="3">
                                                                    Prima{" "}
                                                                    {moment()
                                                                        .month(month - 1)
                                                                        .format("MMM")}{" "}
                                                                    {beforeYearBySelect}
                                                                </option>
                                                                <option value="4">
                                                                    Prima{" "}
                                                                    {moment()
                                                                        .month(month - 1)
                                                                        .format("MMM")}{" "}
                                                                    {before2YearBySelect}
                                                                </option>
                                                            </Form.Select>
                                                        </Form>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {mode ? (
                                <SwitchComponentProd
                                    className="ms-3 mb-2"
                                    isOn={valueSwitch}
                                    handleToggle={(e) => {
                                        setValueSwitch(!valueSwitch);
                                    }}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="d-flex flex-column justify-content-between align-items-end">
                            <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                                <Form>
                                    <Form.Control
                                        type="search"
                                        placeholder="Buscar"
                                        className="ws_input"
                                        onChange={(e) => {
                                            setSearch(e.target.value);
                                        }}
                                    />
                                </Form>
                            </div>
                            <Button
                                className="mt-3 btn btn-primary ws_btn_secundary"
                                onClick={(e) => {
                                    setMode(!mode);
                                }}
                            >
                                {mode ? "Ver Prod / Cobr" : "Ver Crecimiento"}
                            </Button>
                        </div>
                    </div>

                    {mode ? (
                        <div className="table-responsive" style={{ maxHeight: 450 }}>
                            <Table striped bordered hover size="sm" className="ws_tabla">
                                <thead
                                    style={{
                                        backgroundColor: "#0a93af",
                                        color: "#fff",
                                        fontSize: ".9rem",
                                    }}
                                >
                                    <tr>
                                        <th align="left" className="ps-3">
                                            OFICINA
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloCobAcumYearBefore}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloPorcentajeSiniYearBefore}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloCobAcumYearMonthBefore}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloCobAcumYearMonthCurrent}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloCobIncreaseMonth}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloCobLast12Months}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloCobIncreaseYear}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloPorcentajeSiniMonthCurrent}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloPorcentajeSinVS1}
                                        </th>
                                        <th className="text-center">
                                            {dataOficinas.tituloPorcentajeSinVS2}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: ".9rem" }}>
                                    {info_oficinas.map((oficina, index) => {
                                        if (
                                            search === "" ||
                                            (oficina.clave_oficina &&
                                                oficina.clave_oficina.toString().indexOf(search) !==
                                                -1) ||
                                            (oficina.nombre_oficina &&
                                                oficina.nombre_oficina
                                                    .toLowerCase()
                                                    .indexOf(search.toLowerCase()) !== -1)
                                        ) {
                                            return (
                                                <tr key={index}>
                                                    <td align="left" className="ps-3" width="25%">
                                                        <span
                                                            className="ws_color_secundario"
                                                            style={{ fontWeight: "700", marginRight: 10 }}
                                                        >
                                                            {oficina.clave_oficina}
                                                        </span>
                                                        <span>
                                                            <Link
                                                                to={`/oficinas/${oficina.clave_oficina}`}
                                                                style={{ color: "#606060" }}
                                                            >
                                                                {oficina.nombre_oficina}
                                                            </Link>
                                                        </span>
                                                        <p className="mb-0 mt-0">Total de agentes: {oficina.total_agentes}</p>
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center"> 
                                                        $
                                                        {valueSwitch
                                                            ? number_format(oficina.cobAcumYearBefore, 2)
                                                            : number_format(oficina.prodAcumYearBefore, 2)}
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">{oficina.porcentajeSiniYearBefore}%</td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">
                                                        $
                                                        {valueSwitch
                                                            ? number_format(oficina.cobAcumYearMonthBefore, 2)
                                                            : number_format(
                                                                oficina.prodAcumYearMonthBefore,
                                                                2
                                                            )}
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">
                                                        $
                                                        {valueSwitch
                                                            ? number_format(
                                                                oficina.cobAcumYearMonthCurrent,
                                                                2
                                                            )
                                                            : number_format(
                                                                oficina.prodAcumYearMonthCurrent,
                                                                2
                                                            )}
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">
                                                        {valueSwitch
                                                            ? oficina.cobIncreaseMonth
                                                            : oficina.prodIncreaseMonth}
                                                        %
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">
                                                        $
                                                        {valueSwitch
                                                            ? number_format(oficina.cobLast12Months, 2)
                                                            : number_format(oficina.prodLast12Months, 2)}
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">
                                                        {valueSwitch
                                                            ? oficina.cobIncreaseYear
                                                            : oficina.prodIncreaseYear}
                                                        %
                                                    </td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">{oficina.porcentajeSiniMonthCurrent}%</td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">{oficina.porcentajeSinVS1}%</td>
                                                    <td style={{verticalAlign:'middle'}} className="text-center">{oficina.porcentajeSinVS2}%</td>
                                                </tr>
                                            );
                                        }
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="table-responsive" style={{ maxHeight: 450 }}>
                            <Table striped bordered hover size="sm" className="ws_tabla">
                                <thead
                                    style={{
                                        backgroundColor: "#0a93af",
                                        color: "#fff",
                                        fontSize: ".9rem",
                                    }}
                                >
                                    <tr>
                                        <th className="text-left ps-3" width="25%">
                                            OFICINA
                                        </th>
                                        {/*<th className="text-center">% Sin Sep 2021</th>*/}
                                        <th className="text-center">Acum Anual {yearG}</th>
                                        <th className="text-center">
                                            Prima{" "}
                                            {moment()
                                                .month(month - 1)
                                                .format("MMM")}{" "}
                                            {yearG}
                                        </th>
                                        <th className="text-center">
                                            Prima{" "}
                                            {moment()
                                                .month(month - 1)
                                                .format("MMM")}{" "}
                                            {beforeYearBySelect}
                                        </th>
                                        <th className="text-center">
                                            Prima{" "}
                                            {moment()
                                                .month(month - 1)
                                                .format("MMM")}{" "}
                                            {before2YearBySelect}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: ".9rem" }}>
                                    {filteredData.map((oficina, index) => {
                                       return (
                                            <tr key={index}>
                                                <td align="left" className="ps-3">
                                                    <span
                                                        className="ws_color_secundario"
                                                        style={{ fontWeight: "700", marginRight: 10 }}
                                                    >
                                                        {oficina.clave_oficina}
                                                    </span>
                                                    <span>
                                                        <Link
                                                            to={`/oficinas/${oficina.clave_oficina}`}
                                                            style={{ color: "#606060" }}
                                                        >
                                                            {oficina.nombre_oficina}
                                                        </Link>
                                                    </span>
                                                    <p className="mb-0 mt-0">Total de agentes: {oficina.total_agentes}</p>
                                                </td>
                                                <td style={{verticalAlign:'middle'}} className="text-center">
                                                    ${number_format(oficina.cobAcumYearCurrent, 2)}
                                                </td>
                                                <td style={{verticalAlign:'middle'}} className="text-center">
                                                    $
                                                    {number_format(
                                                        oficina.months_current.find(
                                                            (element) => element.mes == month
                                                        ).cobranza,
                                                        2
                                                    )}
                                                </td>
                                                <td style={{verticalAlign:'middle'}} className="text-center">
                                                    $
                                                    {number_format(
                                                        oficina.months_before.find(
                                                            (element) => element.mes == month
                                                        ).cobranza,
                                                        2
                                                    )}
                                                </td>
                                                <td style={{verticalAlign:'middle'}} className="text-center">
                                                    $
                                                    {number_format(
                                                        oficina.months_before2.find(
                                                            (element) => element.mes == month
                                                        ).cobranza,
                                                        2
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Container>
            </div>
        </Col>
    );

    function getAvancesAllOficinas() {
        const dataSend = {
            id_login: usuario.id_usuario,
            opt: dataSelect.opt,
            year: yearG,
            agentes: dataSelect.selectedAgentes,
            tipo_agente: dataSelect.selectedTipos,
        };

        fetch(
            `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvancesAllOficinas`,
            {
                method: "POST",
                mode: "cors",
                body: JSON.stringify(dataSend),
            }
        )
            .then((res) => res.json())
            .then((res) => {
                if (loadDataOficinas) {
                    setLoadDataOficinas(false);
                }
                setLoadDataTable(false);
                setLoad(false);
                updateState({
                    dataOficinas: res,
                });
            });
    }

}
